<script lang="ts">
  import { toastMessage, toastUndo, runToastUndo } from "../lib/stores";
</script>

<!-- role=status so a screen reader hears the result of a drag it can't see. -->
<div id="toast" class:show={$toastMessage !== ""} role="status" aria-live="polite">
  <span class="toast-msg">{$toastMessage}</span>
  {#if $toastUndo}
    <button class="toast-undo" type="button" on:click={runToastUndo}>Undo</button>
  {/if}
</div>
